import { Form, FormItemProps, Input, InputNumber } from "antd";
import React from "react";
import { BasePriceModel } from "../../types/model/price";
import { limitMaxTwoDecimalsInput } from "../../utils/limitMaxTwoDecimalsInput";
import styles from "./index.module.scss";

interface EditableCellProps {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: BasePriceModel;
  index: number;
  children: React.ReactNode;
  maxInputNumber?: number;
  formItemClassName?: string;
  numberRules?: FormItemProps["rules"];
  textRules?: FormItemProps["rules"];
}

function EditableCell({
  maxInputNumber,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  children,
  formItemClassName = undefined,
  numberRules = [],
  textRules = [],
  ...restProps
}: EditableCellProps) {
  const isNumber = inputType === "number";
  const typeSpecificRules = isNumber ? numberRules : textRules;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} style={{ margin: 0 }} rules={typeSpecificRules} className={formItemClassName}>
          {isNumber ? (
            <InputNumber
              type={"number"}
              className={styles.editableCellInputNumber}
              onKeyPress={limitMaxTwoDecimalsInput}
              max={maxInputNumber}
            />
          ) : (
            <Input />
          )}
        </Form.Item>
      ) : (
        <div>{children}</div>
      )}
    </td>
  );
}

export default EditableCell;
